/**
 * The kinds of event a plan can be, and what each one changes about a new table.
 *
 * Deliberately few. Each kind has to earn its place with a starter room that
 * actually differs (`templates.ts`) — "birthday" and "anniversary" would be the
 * same room under two names, so they are both a celebration.
 */

import { DEFAULT_SEAT_COUNTS } from './geometry'
import type { DefaultSeats, EventKind } from './types'

/** In the order the chooser shows them: weddings first. */
export const EVENT_KINDS: readonly EventKind[] = ['wedding', 'celebration', 'corporate', 'other']

export const isEventKind = (value: unknown): value is EventKind =>
  typeof value === 'string' && (EVENT_KINDS as readonly string[]).includes(value)

/**
 * Chairs on a new head table. A wedding's is the couple's table, so two; a
 * company dinner's seats the hosts and their guests of honour.
 */
const HEAD_SEATS: Record<EventKind, number> = {
  wedding: 2,
  celebration: 4,
  corporate: 6,
  other: 4,
}

/** What a new table of each shape is born with in a plan of this kind. */
export function defaultSeatsFor(kind: EventKind): DefaultSeats {
  return { ...DEFAULT_SEAT_COUNTS, sweetheart: HEAD_SEATS[kind] }
}
